import React from 'react';
import GroupImage from '../Images/group.svg';
import minpolicy from '../Images/minpolicy.svg';
import assistance from '../Images/assistance.svg';
import support from '../Images/support.svg';
import ocomp from '../Images/Onlincomp.png';
import ratting from '../Images/rating.svg';
import google from "../Images/GoogleReview.webp";
import rattings from "../Images/ratings.svg";
import { useHistory } from 'react-router-dom';
import { HomeForm } from './HomeForm';

const Home = () => {
    const history = useHistory();

    return (
        <div className="IndemnityUI IndemnityLayout">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="profes_indemnity only_inden">
                            <h1><span className="green-text"> Professional Indemnity </span> Insurance</h1>
                            <p>Professional indemnity insurance covers negligence in professional services.</p>
                            <span>Secure <b>₹25 Lakh</b> coverage for as low as <b>₹558/year*</b></span>
                            <div className="only_view">
                                <div className="Support">
                                    <div className="SuPPT">
                                        <div className="SuPPTBackg">
                                            <img src={minpolicy} />
                                        </div>
                                        <small>Get policy in <br />2 minutes</small>
                                    </div>
                                    <div className="SuPPT">
                                        <div className="SuPPTBackg">
                                            <img src={support} />
                                        </div>
                                        <small>Expert <br />support</small>
                                    </div>
                                    <div className="SuPPT">
                                        <div className="SuPPTBackg">
                                            <img src={assistance} />
                                        </div>
                                        <small>Professional <br />claim assistance</small>
                                    </div>
                                </div>
                                <div className="SuPPT">
                                    <img src={ocomp} />
                                </div>
                                <div className="SuPPT">
                                    <div>
                                        <img src={GroupImage} />
                                    </div>
                                </div>
                                <a href="/customer-reviews" target="_blank">
                                    <div className="SuPPT rating">
                                        <div className="indem-rate">
                                            <img src={google} className="indem_googl" />
                                            <div>
                                                <img src={rattings} className="indem_star" />
                                            </div>
                                        </div>
                                        <small>Highly rated insurance website</small>
                                    </div>
                                </a>
                                <div className="condition_apply"><p><i><sup>* </sup> Conditions Applied</i></p></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 offset-lg-1">
                        <div className="indemnity_userform indem">
                            <h3>Business Details</h3>
                            <HomeForm IsEditForm={false} onSubmit={(data) => history.push("Quotation", data)} />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Home;
